import React from 'react';
import '../styles/AboutInstitute.css';

const AboutInstitute = () => {
  return (
    <section className="about-institute">
      <div className="container">
        <div className="institute-content">
          <h2 className="section-title">About The Institute & Department</h2>

          <div className="institute-section">
            <h3>Birla Institute of Technology (BIT), Mesra</h3>
            <p>
              Birla Institute of Technology (BIT), Mesra, established in 1955, is a premier technical institute in India known for its academic excellence, innovation, and contributions to engineering and research. Among its flagship programs, the Department of Computer Science and Engineering (CSE) stands out as a hub of advanced learning, fostering both theoretical foundations and practical expertise in computing.
            </p>
            <p>
              The department offers undergraduate, postgraduate, and doctoral programs, equipping students with knowledge in areas such as artificial intelligence, machine learning, data science, cybersecurity, and high-performance computing. Its research environment is dynamic and interdisciplinary, supported by well-equipped laboratories, modern computational facilities, and active collaborations with academia and industry.
            </p>
            <p>
              Faculty members and research scholars are engaged in cutting-edge projects funded by national and international agencies, encouraging innovation and knowledge creation. With a focus on research-driven education, the CSE department nurtures problem-solving, critical thinking, and innovation, preparing students to excel in academia, research, industry, and entrepreneurship.
            </p>
          </div>

          <div className="institute-section">
            <h3>BIT Mesra Lalpur Unit</h3>
            <p>
              With a vision to inspire young minds and professionals, BIT Mesra (Lalpur) Ranchi, was started initially with part-time courses in 1998. Currently, Master of Business Administration (MBA), Master of Computer Application (MCA), Bachelor of Business Administration (BBA), Bachelor of Computer Application (BCA) programs, and Ph.D. are being offered by the institute.
            </p>
          </div>

          <div className="highlights-grid">
            <div className="highlight">
              <h4>🏆 Excellence</h4>
              <p>Premier technical institute known for academic excellence and innovation</p>
            </div>
            <div className="highlight">
              <h4>🔬 Research</h4>
              <p>Dynamic research environment with cutting-edge projects and collaborations</p>
            </div>
            <div className="highlight">
              <h4>📚 Programs</h4>
              <p>Comprehensive undergraduate, postgraduate, and doctoral programs</p>
            </div>
            <div className="highlight">
              <h4>🌍 Global</h4>
              <p>Active collaborations with academia and industry worldwide</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutInstitute;
